import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/all')({
  beforeLoad: () => {
    throw redirect({ to: '/tasks/all' });
  },
});
